<ng-container *ngIf="layout$ | async as state">
  <ng-container *ngIf="state.presentation !== 'hidden'">
    <ng-container *ngIf="{available: available$ | async, favorites: favorites$ | async, hidden: hiddenFavoriteCount$ | async, activeIds: activeIds$ | async, starred: starredKeys$ | async, expanded: expandedGroups$ | async, context: context$ | async, dark: isDarkTheme$ | async, projectNodes: projectNodes$ | async, otherNodes: otherNodes$ | async, byId: byId$ | async} as vm">

      <div *ngIf="isDialog(state) || state.presentation === 'overlay'" class="sn-sidebar-backdrop" aria-hidden="true"
           (click)="close(state)"></div>

      <nav id="sn-sidebar" class="sn-sidebar" aria-label="Main"
           [class.sn-sidebar--expanded]="state.presentation === 'expanded'"
           [class.sn-sidebar--rail]="isRail(state)"
           [class.sn-sidebar--overlay]="state.presentation === 'overlay'"
           [class.sn-sidebar--drawer]="state.presentation === 'drawer'"
           [class.sn-sidebar--open]="isDialog(state)"
           [attr.role]="isDialog(state) ? 'dialog' : null" [attr.aria-modal]="isDialog(state) ? 'true' : null"
           [attr.aria-hidden]="state.presentation === 'drawer' && !state.drawerOpen ? 'true' : null"
           [attr.inert]="state.presentation === 'drawer' && !state.drawerOpen ? '' : null"
           [cdkTrapFocus]="isDialog(state) || state.presentation === 'overlay'">

        <div class="sn-sidebar__head">
          <a class="sn-sidebar__brand" routerLink="/projects" [attr.aria-label]="'Snöball home'">
            <img *ngIf="isRail(state)" class="sn-sidebar__mark" alt="" src="../assets/images/logo_mark_navbar.png">
            <ng-container *ngIf="!isRail(state)">
              <img *ngIf="!vm.dark" class="sn-sidebar__logo" alt="Snöball" src="../assets/images/logo_with_background_and_slogan_new.png">
              <img *ngIf="vm.dark" class="sn-sidebar__logo" alt="Snöball" src="../assets/images/logo_with_background_and_slogan_new-transparent.png">
            </ng-container>
          </a>
          <button *ngIf="state.presentation === 'drawer' || state.presentation === 'overlay'" type="button"
                  class="sn-icon-button sn-sidebar__close" aria-label="Close menu" (click)="close(state)">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </div>

        <div app-nav-project-switcher class="sn-sidebar__project" [variant]="isRail(state) ? 'rail' : 'sidebar'"
             *ngIf="!(isInfluencer$ | async) || vm.context.inProjectContext"></div>

        <div class="sn-sidebar__search" *ngIf="!isRail(state)">
          <app-nav-menu-search variant="sidebar" [limit]="30" (queryChange)="onQueryChange($event)"
                               (picked)="afterPick()"></app-nav-menu-search>
        </div>
        <button *ngIf="isRail(state)" type="button" class="sn-rail-button" aria-label="Search the menu"
                (click)="openPalette()" (mouseenter)="showTooltip('Search the menu', $event)" (mouseleave)="hideTooltip()"
                (focus)="showTooltip('Search the menu', $event)" (blur)="hideTooltip()">
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
        </button>

        <div class="sn-sidebar__scroll" *ngIf="!searching">
          <p *ngIf="!vm.available" class="sn-sidebar__unavailable">
            <span *ngIf="!isRail(state)">Menu unavailable.</span>
            <a href="" (click)="$event.preventDefault(); reload()">Reload</a>
          </p>

          <!-- Favorites -->
          <ng-container *ngIf="vm.favorites?.length || vm.hidden">
            <ng-container *ngIf="!isRail(state); else railFavorites">
              <div class="sn-nav-section">
                <h2 class="sn-nav-heading">Favorites</h2>
                <ul class="sn-nav-list" role="list">
                  <li *ngFor="let favorite of vm.favorites; let first = first; let last = last; trackBy: trackById" class="sn-nav-item sn-favorite">
                    <ng-container *ngIf="renaming !== favorite.key; else renameField">
                      <a *ngIf="!favorite.external" class="sn-nav-link" [routerLink]="favorite.path" [queryParams]="favorite.queryParams"
                         routerLinkActive="sn-nav-link--active" [routerLinkActiveOptions]="{exact: true}" (click)="onNavigate()">
                        <i class="fa-fw sn-nav-icon" [ngClass]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
                        <span class="sn-nav-label" [title]="favorite.label">{{ favorite.label }}
                          <small *ngIf="favorite.detail" class="sn-nav-detail">{{ favorite.detail }}</small>
                        </span>
                      </a>
                      <a *ngIf="favorite.external" class="sn-nav-link" [href]="favorite.href" target="_blank" rel="noopener noreferrer">
                        <i class="fa-fw sn-nav-icon" [ngClass]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
                        <span class="sn-nav-label">{{ favorite.label }}</span>
                        <span class="sr-only"> (opens in a new tab)</span>
                      </a>
                      <button type="button" class="sn-icon-button sn-favorite__more" aria-haspopup="true"
                              [attr.aria-expanded]="menuFor === favorite.key" [attr.aria-label]="'Options for ' + favorite.label"
                              (click)="toggleFavoriteMenu(favorite, $event)">
                        <i class="fa-solid fa-ellipsis" aria-hidden="true"></i>
                      </button>
                      <div *ngIf="menuFor === favorite.key" class="sn-favorite__menu">
                        <button type="button" [disabled]="first" (click)="moveFavorite(favorite, -1)"><i class="fa-solid fa-arrow-up fa-fw" aria-hidden="true"></i> Move up</button>
                        <button type="button" [disabled]="last" (click)="moveFavorite(favorite, 1)"><i class="fa-solid fa-arrow-down fa-fw" aria-hidden="true"></i> Move down</button>
                        <button type="button" (click)="startRename(favorite)"><i class="fa-solid fa-pen fa-fw" aria-hidden="true"></i> Rename</button>
                        <button type="button" (click)="removeFavorite(favorite)"><i class="fa-solid fa-trash-can fa-fw" aria-hidden="true"></i> Remove</button>
                      </div>
                    </ng-container>
                    <ng-template #renameField>
                      <input #rename class="sn-favorite__rename" type="text" maxlength="120" [value]="favorite.label"
                             [attr.aria-label]="'Rename ' + favorite.label"
                             (keydown.enter)="finishRename(favorite, rename.value)" (keydown.escape)="$event.stopPropagation(); cancelRename()"
                             (blur)="finishRename(favorite, rename.value)">
                    </ng-template>
                  </li>
                </ul>
                <p *ngIf="vm.hidden" class="sn-nav-note">{{ vm.hidden }} {{ vm.hidden === 1 ? 'favorite is' : 'favorites are' }} not available here.</p>
              </div>
            </ng-container>
            <ng-template #railFavorites>
              <button *ngIf="vm.favorites?.length" type="button" class="sn-rail-button" [attr.data-sn-flyout-trigger]="FAVORITES_FLYOUT"
                      aria-haspopup="true" [attr.aria-expanded]="flyout?.id === FAVORITES_FLYOUT" aria-label="Favorites"
                      (mouseenter)="flyoutEnter(FAVORITES_FLYOUT, 'Favorites', $event)" (mouseleave)="flyoutLeave()"
                      (click)="flyoutClick(FAVORITES_FLYOUT, 'Favorites', $event)" (keydown)="flyoutKeydown(FAVORITES_FLYOUT, 'Favorites', $event)">
                <i class="fa-solid fa-star" aria-hidden="true"></i>
              </button>
            </ng-template>
          </ng-container>

          <!-- The project on screen -->
          <div *ngIf="vm.projectNodes?.length" class="sn-nav-section sn-nav-section--tree sn-nav-section--project">
            <h2 *ngIf="!isRail(state)" class="sn-nav-heading" [title]="vm.context.project?.title || ''">
              {{ vm.context.project?.title || 'This project' }}
            </h2>
            <div *ngIf="isRail(state)" class="sn-rail-separator" role="separator"></div>
            <ng-container *ngTemplateOutlet="isRail(state) ? railList : tree; context: {$implicit: vm.projectNodes, depth: 0, vm: vm}"></ng-container>
          </div>

          <div class="sn-nav-section sn-nav-section--tree">
            <div *ngIf="vm.projectNodes?.length && isRail(state)" class="sn-rail-separator" role="separator"></div>
            <ng-container *ngTemplateOutlet="isRail(state) ? railList : tree; context: {$implicit: vm.otherNodes, depth: 0, vm: vm}"></ng-container>
          </div>
        </div>

        <div class="sn-sidebar__foot" *ngIf="state.canCollapse">
          <button type="button" class="sn-sidebar__collapse" (click)="toggleCollapsed()"
                  [attr.aria-label]="isRail(state) ? 'Expand menu' : (state.presentation === 'overlay' ? 'Close menu' : 'Collapse menu')"
                  [attr.aria-expanded]="!isRail(state)" aria-controls="sn-sidebar"
                  (mouseenter)="isRail(state) && showTooltip('Expand menu', $event)" (mouseleave)="hideTooltip()">
            <i class="fa-solid" [class.fa-angles-right]="isRail(state)" [class.fa-angles-left]="!isRail(state)" aria-hidden="true"></i>
            <span *ngIf="!isRail(state)" class="sn-sidebar__collapse-label">Collapse</span>
          </button>
        </div>
      </nav>

      <!-- The expanded menu tree: groups open in place. -->
      <ng-template #tree let-nodes let-depth="depth" let-vm="vm">
        <ul class="sn-nav-list" role="list">
          <ng-container *ngFor="let node of nodes; trackBy: trackById">
            <li *ngIf="node.type === 'divider'" class="sn-nav-divider" role="separator">
              <span *ngIf="node.label" class="sn-nav-heading">{{ node.label }}</span>
            </li>
            <li *ngIf="node.type === 'link'" class="sn-nav-item" [style.--sn-level]="depth">
              <a *ngIf="!node.external" class="sn-nav-link" [class.sn-nav-link--active]="vm.activeIds.has(node.id)"
                 [attr.aria-current]="vm.activeIds.has(node.id) ? 'page' : null"
                 [routerLink]="node.path" [queryParams]="node.queryParams" (click)="onNavigate()">
                <i class="fa-fw sn-nav-icon" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
                <span class="sn-nav-label" [title]="node.label">{{ node.label }}</span>
              </a>
              <a *ngIf="node.external" class="sn-nav-link" [href]="node.href" target="_blank" rel="noopener noreferrer">
                <i class="fa-fw sn-nav-icon" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
                <span class="sn-nav-label" [title]="node.label">{{ node.label }}</span>
                <i class="fa-solid fa-arrow-up-right-from-square sn-nav-external" aria-hidden="true"></i>
                <span class="sr-only"> (opens in a new tab)</span>
              </a>
              <button type="button" class="sn-star" [class.sn-star--on]="isStarred(node, vm.starred)"
                      [attr.aria-pressed]="isStarred(node, vm.starred)" [attr.aria-label]="'Favorite ' + node.label"
                      [title]="isStarred(node, vm.starred) ? 'Remove from favorites' : 'Add to favorites'"
                      (click)="toggleStar(node, vm.starred, $event)">
                <i [ngClass]="isStarred(node, vm.starred) ? 'fa-solid fa-star' : 'fa-regular fa-star'" aria-hidden="true"></i>
              </button>
            </li>
            <li *ngIf="node.type === 'group'" class="sn-nav-item sn-nav-group" [style.--sn-level]="depth">
              <button type="button" class="sn-nav-link sn-nav-group__toggle"
                      [class.sn-nav-link--ancestor]="vm.activeIds.has(node.id)"
                      [attr.aria-expanded]="isOpen(node, vm.expanded, vm.activeIds)" [attr.aria-controls]="'sn-grp-' + node.id"
                      (click)="toggleGroup(node, vm.expanded, vm.activeIds)">
                <i class="fa-fw sn-nav-icon" [ngClass]="node.icon || 'fa-solid fa-folder'" aria-hidden="true"></i>
                <span class="sn-nav-label">{{ node.label }}</span>
                <i class="fa-solid fa-chevron-right sn-nav-chevron" [class.sn-nav-chevron--open]="isOpen(node, vm.expanded, vm.activeIds)" aria-hidden="true"></i>
              </button>
              <div [id]="'sn-grp-' + node.id" *ngIf="isOpen(node, vm.expanded, vm.activeIds)">
                <ng-container *ngTemplateOutlet="tree; context: {$implicit: node.children, depth: depth + 1, vm: vm}"></ng-container>
              </div>
            </li>
          </ng-container>
        </ul>
      </ng-template>

      <!-- The rail: top-level icons; a group opens as a flyout beside it. -->
      <ng-template #railList let-nodes let-vm="vm">
        <ul class="sn-nav-list sn-nav-list--rail" role="list">
          <ng-container *ngFor="let node of nodes; trackBy: trackById">
            <li *ngIf="node.type === 'link'" class="sn-nav-item">
              <a *ngIf="!node.external" class="sn-rail-button" [class.sn-nav-link--active]="vm.activeIds.has(node.id)"
                 [attr.aria-current]="vm.activeIds.has(node.id) ? 'page' : null"
                 [routerLink]="node.path" [queryParams]="node.queryParams"
                 (mouseenter)="showTooltip(node.label, $event)" (mouseleave)="hideTooltip()"
                 (focus)="showTooltip(node.label, $event)" (blur)="hideTooltip()">
                <i class="fa-fw" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
                <span class="sr-only">{{ node.label }}</span>
              </a>
              <a *ngIf="node.external" class="sn-rail-button" [href]="node.href" target="_blank" rel="noopener noreferrer"
                 (mouseenter)="showTooltip(node.label, $event)" (mouseleave)="hideTooltip()"
                 (focus)="showTooltip(node.label, $event)" (blur)="hideTooltip()">
                <i class="fa-fw" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
                <span class="sr-only">{{ node.label }} (opens in a new tab)</span>
              </a>
            </li>
            <li *ngIf="node.type === 'group'" class="sn-nav-item">
              <button type="button" class="sn-rail-button" [class.sn-nav-link--ancestor]="vm.activeIds.has(node.id)"
                      [attr.data-sn-flyout-trigger]="node.id" aria-haspopup="true" [attr.aria-expanded]="flyout?.id === node.id"
                      (mouseenter)="flyoutEnter(node.id, node.label, $event)" (mouseleave)="flyoutLeave()"
                      (click)="flyoutClick(node.id, node.label, $event)" (keydown)="flyoutKeydown(node.id, node.label, $event)">
                <i class="fa-fw" [ngClass]="node.icon || 'fa-solid fa-folder'" aria-hidden="true"></i>
                <span class="sr-only">{{ node.label }}</span>
              </button>
            </li>
          </ng-container>
        </ul>
      </ng-template>

      <!-- The rail's flyout: a group's entries, nested groups as headings. -->
      <div *ngIf="flyout && isRail(state)" class="sn-flyout" [style.top.px]="flyout.top" role="group" [attr.aria-label]="flyout.label"
           (mouseenter)="keepFlyout()" (mouseleave)="flyoutLeave()" (keydown)="flyoutItemKeydown($event)">
        <div class="sn-flyout__title">{{ flyout.label }}</div>
        <ng-container *ngIf="flyout.id === FAVORITES_FLYOUT; else groupFlyout">
          <ng-container *ngFor="let favorite of vm.favorites; trackBy: trackById">
            <a *ngIf="!favorite.external" class="sn-flyout__link" [routerLink]="favorite.path"
               [queryParams]="favorite.queryParams" (click)="closeFlyout()">
              <i class="fa-fw sn-nav-icon" [ngClass]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
              <span>{{ favorite.label }}</span>
            </a>
            <a *ngIf="favorite.external" class="sn-flyout__link" [href]="favorite.href" target="_blank"
               rel="noopener noreferrer" (click)="closeFlyout()">
              <i class="fa-fw sn-nav-icon" [ngClass]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
              <span>{{ favorite.label }}</span>
              <span class="sr-only"> (opens in a new tab)</span>
            </a>
          </ng-container>
        </ng-container>
        <ng-template #groupFlyout>
          <ng-container *ngTemplateOutlet="flyoutItems; context: {$implicit: vm.byId.get(flyout.id)?.children, vm: vm}"></ng-container>
        </ng-template>
      </div>

      <ng-template #flyoutItems let-nodes let-vm="vm">
        <ng-container *ngFor="let node of nodes; trackBy: trackById">
          <div *ngIf="node.type === 'divider'" class="sn-flyout__divider" role="separator"></div>
          <ng-container *ngIf="node.type === 'group'">
            <div class="sn-flyout__heading">{{ node.label }}</div>
            <ng-container *ngTemplateOutlet="flyoutItems; context: {$implicit: node.children, vm: vm}"></ng-container>
          </ng-container>
          <div *ngIf="node.type === 'link'" class="sn-flyout__row">
            <a *ngIf="!node.external" class="sn-flyout__link" [class.sn-nav-link--active]="vm.activeIds.has(node.id)"
               [attr.aria-current]="vm.activeIds.has(node.id) ? 'page' : null"
               [routerLink]="node.path" [queryParams]="node.queryParams" (click)="closeFlyout()">
              <i class="fa-fw sn-nav-icon" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
              <span>{{ node.label }}</span>
            </a>
            <a *ngIf="node.external" class="sn-flyout__link" [href]="node.href" target="_blank" rel="noopener noreferrer" (click)="closeFlyout()">
              <i class="fa-fw sn-nav-icon" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
              <span>{{ node.label }}</span>
              <span class="sr-only"> (opens in a new tab)</span>
            </a>
            <button type="button" class="sn-star" [class.sn-star--on]="isStarred(node, vm.starred)"
                    [attr.aria-pressed]="isStarred(node, vm.starred)" [attr.aria-label]="'Favorite ' + node.label"
                    (click)="toggleStar(node, vm.starred, $event)">
              <i [ngClass]="isStarred(node, vm.starred) ? 'fa-solid fa-star' : 'fa-regular fa-star'" aria-hidden="true"></i>
            </button>
          </div>
        </ng-container>
      </ng-template>

      <div *ngIf="tooltip && isRail(state)" class="sn-rail-tooltip" [style.top.px]="tooltip.top" aria-hidden="true">{{ tooltip.text }}</div>
    </ng-container>
  </ng-container>
</ng-container>
